module.exports = __webpack_public_path__ + "static/ebay-45bc84be8e9e645c6258227c2a2b44dd.jpg";